import { createContext, useState } from "react";

const NlaContext = createContext();

const NlaProvider = ({children, part}) => {

    const [openedNode, setOpenedNode] = useState({[part.id]: true});
    const [editing, setEditing] = useState({});
    const [parts, setParts] = useState({});
    const [partsBackup, setPartsBackup] = useState({});
    // const [partsToDisconnect, setPartsTo]

    const openNode = (node) => {
        setOpenedNode(prev => ({...prev, [node.id]: true}));
    }

    const closeNode = (node) => {
        setOpenedNode(prev => {
            let copy = {...prev};
            delete copy[node.id];
            return copy
        })
    }

    const startEditing = (node) => {
        setEditing(prev => ({...prev, [node.id]: node}));
    } 

    const closeEditing = (node) => {
        setEditing(prev => {
            let copy = {...prev};
            delete copy[node.id];
            return copy
        });
    }

    const isNodeOpen = (node) => node.id  in openedNode;
    const isNodeOnEdition = (node) => node.id in editing;
    const showNode = (node) => node.parents?.every(p => p in openedNode);

    return(<NlaContext.Provider value={{openNode, closeNode, isNodeOpen, showNode, startEditing, closeEditing, isNodeOnEdition, parts, setParts, partsBackup, setPartsBackup}}>
        {children}
    </NlaContext.Provider>)
}

export {NlaContext, NlaProvider}